"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollBarExists = exports.isManualResizing = exports.isHeaderResizer = exports.agColIds = exports.isMeasureColumn = exports.isColumn = exports.getGridIndex = void 0;
var constants_1 = require("./constants");
var tableDescriptorTypes_1 = require("../structure/tableDescriptorTypes");
var columnWidths_1 = require("../../columnWidths");
/*
 * Assorted utility functions used in our Pivot Table -> ag-grid integration.
 */
function getGridIndex(position, gridDistance) {
    return Math.floor(position / gridDistance);
}
exports.getGridIndex = getGridIndex;
function isColumn(item) {
    return !!item.getColDef;
}
exports.isColumn = isColumn;
function isMeasureColumn(item) {
    if (isColumn(item)) {
        return item.getColDef().type === constants_1.MEASURE_COLUMN;
    }
    return item.type === constants_1.MEASURE_COLUMN;
}
exports.isMeasureColumn = isMeasureColumn;
function agColIds(columns) {
    return columns.map(tableDescriptorTypes_1.agColId);
}
exports.agColIds = agColIds;
function isHeaderResizer(target) {
    return target.classList.contains("ag-header-cell-resize");
}
exports.isHeaderResizer = isHeaderResizer;
function isManualResizing(columnEvent) {
    return Boolean((columnEvent === null || columnEvent === void 0 ? void 0 : columnEvent.source) === columnWidths_1.ColumnEventSourceType.UI_DRAGGED && columnEvent.columns);
}
exports.isManualResizing = isManualResizing;
function scrollBarExists(target) {
    var _a = target.getElementsByClassName("ag-body-horizontal-scroll-viewport")[0], scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return scrollWidth > clientWidth;
}
exports.scrollBarExists = scrollBarExists;
//# sourceMappingURL=agUtils.js.map